var styles = {
  "SearchField": "Polaris-Picker-SearchField"
};

export { styles as default };
